import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-network-status-guide',
  templateUrl: './network-status-guide.component.html',
  styleUrls: ['./network-status-guide.component.scss']
})
export class NetworkStatusGuideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
